import { z } from "zod";

const addressField = z
  .string()
  .nullish()
  .transform((value) => value ?? "");
const savedBillingAddressSchema = z
  .object({
    street_address: addressField,
    extended_address: addressField,
    city: addressField,
    region: addressField,
    postal_code: addressField,
    country: addressField,
  })
  .transform(({ extended_address, ...address }) => ({
    ...address,
    street_address: [address.street_address, extended_address]
      .filter(Boolean)
      .join("\n"),
  }));

const savedPaymentMethodSchema = z
  .object({
    token: z.string(),
    card_type: z.string(),
    last_four: z.string(),
    expiration_month: z.string(),
    expiration_year: z.string(),
    billing_address: savedBillingAddressSchema.nullish(),
  })
  .transform((input) => ({
    token: input.token,
    cardType: input.card_type,
    lastFour: input.last_four,
    expirationMonth: input.expiration_month,
    expirationYear: input.expiration_year,
    billingAddress: input.billing_address,
  }));

const boostPreparePaymentCardSchema = z
  .object({
    client_token: z.string(),
    payment_methods: z.array(savedPaymentMethodSchema).default([]),
  })
  .transform((input) => ({
    clientToken: input.client_token,
    paymentMethods: input.payment_methods,
  }));

type SavedPaymentMethod = z.infer<typeof savedPaymentMethodSchema>;
type BoostPreparePaymentCard = z.infer<typeof boostPreparePaymentCardSchema>;

export {
  savedPaymentMethodSchema,
  boostPreparePaymentCardSchema,
  type SavedPaymentMethod,
  type BoostPreparePaymentCard,
};
